// Components==============
import { useToken } from 'hooks/useToken';
import React from 'react';
import Token from '../Token/Token';
import TrainingCard from '../TrainingCard/TrainingCard';
import './TokenGetter.module.scss';
// =========================

export default function TokenGetter({
  activity,
  requirement,
  small,
  handleDelete,
}: {
  activity?:
    | ProcessEntity
    | {
        process_type: ProcessType;
        process_id: number;
      };
  requirement?: RequirementEntity;
  small?: boolean;
  handleDelete?: () => void;
}) {
  const token = useToken(activity, requirement);

  if (small)
    return (
      <>
        {token && 'thumbnail' in token ? (
          <Token token={token} withMargin small />
        ) : (
          <div styleName="small-training" />
        )}
      </>
    );

  return (
    <>
      {token && 'thumbnail' in token ? (
        <Token token={token} withMargin handleDelete={handleDelete} />
      ) : token?.id ? (
        <div
          styleName={`training-wrapper ${handleDelete ? 'dream-modal' : ''}`}
        >
          <TrainingCard
            training={token}
            withModal
            small
            handleDelete={handleDelete}
          />
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
